import { render, staticRenderFns } from "./SubmitReviewButton.vue?vue&type=template&id=6843ae66&scoped=true&"
import script from "./SubmitReviewButton.vue?vue&type=script&lang=js&"
export * from "./SubmitReviewButton.vue?vue&type=script&lang=js&"
import style0 from "./SubmitReviewButton.vue?vue&type=style&index=0&id=6843ae66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843ae66",
  null
  
)

export default component.exports